export default __webpack_public_path__ + "static/media/thumbnail-2.373154aa.jpg";